import React from "react";
import $ from "jquery";
import { QueryParam, API_PASSWORD_RESET } from "../Util";
import { Input } from "react-materialize";
import { notify } from "react-notify-toast";
import Login from "./Login";

class ResetPassword extends Login {
  constructor(props) {
    super(props);
    this.state = { params: QueryParam() };
  }

  handlePasswordChange = (e) => {
    this.handleInputChange(e);
    this.validatePassword();
  };

  validatePassword = (e) => {
    var password = document.getElementById("password"),
      confirm_password = document.getElementById("confirm_password");

    if (password.value != confirm_password.value) {
      confirm_password.setCustomValidity("Passwords Don't Match");
    } else {
      confirm_password.setCustomValidity("");
    }
  };

  handleSubmitForm = (e) => {
    e.preventDefault();
    let param = {
      email: this.state.params["email"],
      token: this.state.params["token"],
      password: this.state.password,
      password_confirmation: this.state.confirm_password,
    };
    $.post(API_PASSWORD_RESET, param).then((data) => {
      notify.show(data.payload, "success");
      this.props.history.push("/login");
    });
  };

  render() {
    return (
      <div>
        <div
          className="pt-m pad-xl fullheight bg-cover"
          style={{ backgroundImage: "url('../img/login/bg.png')" }}
        >
          <form
            id="form-login"
            className="form-auth bg-white"
            onSubmit={this.handleSubmitForm}
          >
            <div className="pad-m">
              <div className="center mb-m mt-s">
                <h4>Reset Password</h4>
              </div>
              <p className="mb-s">Masukkan password baru Anda</p>
              <Input
                onChange={this.handlePasswordChange}
                type="password"
                id="password"
                s={12}
                label="Password"
                required
              />
              <Input
                onChange={this.handlePasswordChange}
                type="password"
                id="confirm_password"
                s={12}
                label="Password Confirmation"
                required
              />
              <button className="btn s12 full">RESET PASSWORD</button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
export default ResetPassword;



// WEBPACK FOOTER //
// ./src/components/Auth/ResetPassword.js